export default function Upload({ styles, color, width = '24', height = '24' }) {
  return (
    <svg
      className={styles}
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.42927 4.66724L11.8426 1.25391L15.2559 4.66724M11.8426 14.9072V1.34724M1.33594 12.0006C1.33594 17.8939 5.33594 22.6672 12.0026 22.6672C18.6693 22.6672 22.6693 17.8939 22.6693 12.0006'
        stroke={color || '#8FC045'}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
